import React, { useState, useEffect } from "react";
import Iconify from "../../components/Iconify";
import {
  Button,
  Typography,
  Box,
  Chip,
  Stack,
  Avatar,
  Tooltip,
} from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import { useNavigate, useParams } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import moment from "moment";
import { show_proper_words } from "../../utils/constant";

const SubscriptionListProfile = ({
  subscription,
  page,
  setPage,
  rowsPerPage,
  totalPages,
  pageCount,
  totalCount,
  setRowsPerPage,
  setPageCount,
}) => {
  const param = useParams();
  const { setnavbarTitle } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [rowDataID, setRowDataID] = useState("");
  const [rowData, setRowData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [isInvestigator, setIsInvestigator] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const User_Table_Head = [
    // {
    //   id: "action",
    //   label: "Action",
    //   renderData: (row) => (
    //     <>
    //       <Tooltip title="View Agency Ad Accounts" placement="top">
    //         <RemoveRedEyeIcon
    //           onClick={() => {
    //             navigate(
    //               `/user-management/user-profile/${param?.id}/agency-ad-accounts`
    //             );
    //           }}
    //           style={{ fill: "#fff", marginRight: "10px", cursor: "pointer" }}
    //         />
    //       </Tooltip>
    //     </>
    //   ),
    // },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "name",
      label: "Plan Title",
      renderData: (row) => (
        <span
        // className="pointer"
        // onClick={() => {
        //   navigate(
        //     `/user-management/user-profile/${param?.id}/agency-ad-accounts`
        //   );
        // }}
        >
          {row?.product_info?.title}
        </span>
      ),
    },
    {
      id: "transaction_date",
      label: "Subscription Date",
      renderData: (row) => (
        <span>
          {moment(row.subscription_start_date).format("DD MMM YYYY hh:mm A")}
        </span>
      ),
    },
    {
      id: "transaction_date_next",
      label: "Next Invoice Date",
      renderData: (row) => (
        <span>
          {moment(row.next_billing_date).format("DD MMM YYYY hh:mm A")}
        </span>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip status={show_proper_words(row.subscription_status)} />
      ),
    },
  ];

  const User_Table_Menu_Options = [
    // {
    //   label: "Edit",
    //   color: "#6d00fc",
    //   icon: "ant-design:edit",
    //   handleClick: handleClickEdit,
    // },
    // {
    //   label: "Delete",
    //   icon: "ant-design:delete-twotone",
    //   color: "red",
    //   handleClick: (row) => {
    //     navigate(`/user-management/edit-user/${row.id}`);
    //   },
    // },
  ];

  useEffect(() => {
    setnavbarTitle("User Management");
  }, []);

  return (
    <div className="">
      <CustomTable
        data={subscription || []}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={User_Table_Menu_Options}
        // custom_search={{
        //   searchText: searchText,
        //   setSearchText: setSearchText,
        //   handleSubmit: searchFunction,
        // }}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        pagePagination={true}
        handleChangePages={handleChangePages}
        is_hide={true}
      />
    </div>
  );
};

export default SubscriptionListProfile;
